import { css } from '../styled';
import { color } from '../theme';

const outline = css`
    outline-width: 2px !important;
    outline-style: solid !important;
    outline-color: ${color('custom.primary.500')} !important;
    outline-color: -webkit-focus-ring-color !important;
    outline-offset: 1px !important;
`;

export default outline;
